export default `
<button type="button" class="close" ng-click="cancel()" autofocus aria-label="Close">
  <i class="icon-cancel"></i>
</button>
<div class="modal-header"></div>
<div class="modal-body text-center">
  <img src="{{src}}" alt="{{alt}}" >
</div>
`;
